import { createAction } from '@reduxjs/toolkit';
import { WixPermissionPack } from '@va/wix/shared/constants';

export const START_UPGRADE_PROCESS = 'START_UPGRADE_PROCESS';
export const START_INTP_UPGRADE = 'START_INTP_UPGRADE';

export type RequiredPlan = {
  /** Preselects the plan with this permission pack on the wix upgrade page. */
  wixPermissionPack?: WixPermissionPack;
  /** Preselects the cheapest 3as plan that includes at least this many credits. */
  aaasMinCredits?: number;
};

export const startUpgradeProcess = createAction<({ websiteId?: string } & RequiredPlan) | undefined>(
  START_UPGRADE_PROCESS,
);
export const startIntpUpgrade = createAction(START_INTP_UPGRADE);
